export default __webpack_public_path__ + "static/media/user_add.dfcdb880.svg";